import { AnalyticsEvents } from '../types/events'
import { buildTrackedRoute, PAGE_HIT, resolveAppType, resolveEventTypes } from '../utils/page-hit'
import { clientPortalAnalyticsService } from '../services/clientportal-analytics.service'
import type { AnalyticsProvider } from './base.provider'

function namedPendoExtraProperties(properties?: Record<string, unknown>): Record<string, string> {
  const extra: Record<string, string> = {}
  const activityType = properties?.activityType
  if (typeof activityType === 'string' && activityType) extra.string1 = activityType
  const funnelId = properties?.funnelId
  if (typeof funnelId === 'string' && funnelId) extra.funnel_id = funnelId
  const courseId = properties?.courseId
  if (typeof courseId === 'string' && courseId) extra.course_id = courseId
  const lessonId = properties?.lessonId
  if (typeof lessonId === 'string' && lessonId) extra.lesson_id = lessonId
  return extra
}

// Formats a service-selected page view into product page-hit events for the Pendo endpoint.
export class PendoAnalyticsProvider implements AnalyticsProvider {
  name = 'PendoAnalytics'

  constructor(private readonly flavor: string) {}

  track(event: string, properties?: Record<string, unknown>): void {
    const locationId = properties?.locationId as string | undefined
    if (!locationId) return

    const contactId = properties?.contactId as string | undefined

    if (event !== AnalyticsEvents.PAGE_VIEW) {
      clientPortalAnalyticsService.trackPageHit({
        eventType: event,
        locationId,
        path: (properties?.pagePath as string) ?? '',
        flavor: this.flavor,
        appType: this.flavor,
        contactId,
        extraProperties: namedPendoExtraProperties(properties),
      })
      return
    }

    const path = (properties?.pagePath as string) ?? ''
    if (!path) return

    const routeName = properties?.routeName as string | undefined
    const route = buildTrackedRoute(path, properties?.activeTab as string | undefined)
    const appType = resolveAppType(route, routeName, this.flavor)

    for (const eventType of resolveEventTypes(path, routeName, this.flavor === 'gokollab')) {
      if (eventType === PAGE_HIT.COURSES && !contactId) continue
      clientPortalAnalyticsService.trackPageHit({ eventType, locationId, path: route, flavor: this.flavor, appType, contactId })
    }
  }
}
